export enum RowType {
    Unknown,
    Title,
    Variable,
    Text,
}
